import { createFileRoute } from '@tanstack/react-router';
import { loadDashboard } from '../api/route-loaders';
import { seesBilling } from '../tenant/role';
import { JobsDashboard } from '../screens/fleet/JobsDashboard';
import { JobsPending } from '../screens/fleet/JobsPending';

/**
 * The jobs are read before the route commits, so the workbench (or wherever the person was) stays
 * until the dashboard can show its rows (IMPLEMENTATION.md, sell-ready sprint 2, row 13). Opened
 * cold there is no screen to stay on, so past a beat the home's own frame shows with quiet cards
 * (`JobsPending`); a read ends after thirty seconds (`readTimeout` in `@paige/api-client`) and jobs that could not
 * be read are a line on the home, never the failure screen (review 2026-10-06).
 */
export const Route = createFileRoute('/t/$tenant/')({
  loader: async ({ context, params }) => {
    // Billing is read for the people the API lets read it (admins, managers, staff; row 49 c).
    const principal = await context.auth.ensure();
    const sees = principal !== null && seesBilling(principal, params.tenant);
    return loadDashboard({ ...context, seesBilling: sees }, params.tenant);
  },
  pendingComponent: JobsPending,
  pendingMs: 600,
  component: JobsDashboard,
});
